import MainPage from '../page/main'
import PowerBI from '../page/powerbi'
import WebhooksPage from '../page/webhooks'

const ContRoutes = [
  { path: '/', component: <MainPage />, index: true },
  { path: 'webhooks', component: <WebhooksPage />, index: false },
  { path: 'powerbi', component: <PowerBI />, index: false },
]

export default ContRoutes
